import * as z from 'zod/mini';
import { createLocalStorageState } from './manager';
import { compressString, decompressString } from '../../compression';

const dataCacheSchema = z.array(
    z.tuple([
        z.string(),
        z.object({
            lastUsedAt: z.number().check(z.nonnegative()),
            value: z.unknown(),
        }),
    ]),
);

export const swrDataCacheGlobalState = createLocalStorageState(
    'swrDataCache',
    (encodedValue) => {
        let unparsed;
        try {
            unparsed = JSON.parse(decompressString(encodedValue));
        } catch (_) {
            unparsed = null;
        }

        return new Map(dataCacheSchema.safeParse(unparsed).data);
    },
    (value) => compressString(JSON.stringify(Array.from(value.entries()))),
);
